import Auth from '@ublend-npm/aula-auth-client';
import { redirectToGeneral } from './institutionUrl';

export const logout = ({ email, institution, returnAfterLogin }) =>
  Auth.requestLogout(email, institution).finally(() =>
    redirectToGeneral({ returnAfterLogin }),
  );
